const SALES_LEADS_URL = process.env.REACT_APP_SALES_LEADS_URL;
const SALES_LEADS_KEY = process.env.REACT_APP_SALES_LEADS_KEY;

export async function submitSalesLead(data) {
  if (!SALES_LEADS_URL || !SALES_LEADS_KEY) {
    throw new Error('Sales API is not configured (missing REACT_APP_SALES_LEADS_URL/KEY)');
  }

  const res = await fetch(SALES_LEADS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${SALES_LEADS_KEY}`,
    },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Sales API responded ${res.status}: ${body}`);
  }
}
